class BackToTopButton extends HTMLElement {
  constructor() {
    super();
    this.config = {
      dom: {
        button: 'backToTopButton',
        sentinel: 'backToTopSentinel',
      },
      cls: {
        visible: 'is-visible',
      },
    };

    this.button = null;
    this.observer = null;
    this.scrollHeightValue = 300;

    this.onClick = this.onClick.bind(this);
    this.onIntersect = this.onIntersect.bind(this);
  }

  connectedCallback() {
    this.button = this.querySelector(`#${this.config.dom.button}`);
    const $sentinel = document.getElementById(this.config.dom.sentinel);

    if (!this.button || !$sentinel) return;

    this.observer = new IntersectionObserver(this.onIntersect, {
      threshold: 0
    });

    this.observer.observe($sentinel);
    this.button.addEventListener('click', this.onClick);

    this.setVisible(window.scrollY > this.scrollHeightValue);
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
    if (this.button) this.button.removeEventListener('click', this.onClick);
  }

  onClick() {
    const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    window.scrollTo({ top: 0, behavior });
  }

  onIntersect(entries) {
    const entry = entries[0];
    this.setVisible(!entry.isIntersecting);
  }

  setVisible(isVisible) {
    if (!this.button) return;
    this.button.classList.toggle(this.config.cls.visible, isVisible);
    this.button.tabIndex = isVisible ? 0 : -1;
  }
}

customElements.define('back-to-top-button', BackToTopButton);
